import React, {Component} from 'react';
import {connect} from 'react-redux'

import {getTrendingCollection} from '../../../services/index'
import {addToCart, addToCompare, addToWishlist} from "../../../actions/index";

class TopCollection extends Component {

    componentDidMount() {
        console.log(this.props.items);
    }

    render (){

        return (
            <div>
                {/*Paragraph*/}
                <div className="title1  section-t-space" style={{marginTop: 50}}>
                    <h4>Fresh</h4>
                    <h2 className="title-inner1" style={{marginBottom: 0}}>New Arrival</h2>
                </div>
                {/*Paragraph End*/}
                {/*<section className="section-b-space p-t-0">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <Slider {...properties} className="product-4 product-m no-arrow">
                                    { items.map((product, index ) =>
                                        <div key={index}>
                                            <ProductItemNewArrival product={product} symbol={symbol}
                                                         onAddToCompareClicked={() => addToCompare(product)}
                                                         onAddToWishlistClicked={() => addToWishlist(product)}
                                                         onAddToCartClicked={() => addToCart(product, 1)} key={index} />
                                        </div>)
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>*/}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    items: getTrendingCollection(state.data.products, ownProps.type),
    symbol: state.data.symbol
})

export default connect(mapStateToProps, {addToCart, addToWishlist, addToCompare}) (TopCollection);